"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=bcfg-types.js.map